import { createContext } from "react";
const FrameHeaderContext = createContext({});

export default FrameHeaderContext;
